<template>
  <van-dialog
    v-model="dialogVisible"
    :show-confirm-button="false"
    width="375px"
    :close-on-click-overlay="true"
    class="active-dialog"
  >
    <div class="active-rule-container">
      <img
        class="rule-title"
        src="@/assets/images/active-rule-title-bg.png"
        alt=""
      />
      <img @click="dialogVisible = false" class="close" src="@/assets/images/rule-icon.png" alt="">
      <div class="rule-content">
        <div class="rule-item">
          <img src="@/assets/images/active-1.png" alt="" />
          <span
            >点击“立即邀请好友”按钮，将您的专属链接分享给他人，通过您链接首次注册平台的用户，将成为您的受邀用户；</span
          >
        </div>
        <div class="rule-item">
          <img src="@/assets/images/active-2.png" alt="" />
          <span> 每增加1位受邀用户，您即可获得1张满6-3优惠券；</span>
        </div>
        <div class="rule-item">
          <img src="@/assets/images/active-3.png" alt="" />
          <span>
            每1位受邀用户首次在APP上充值超过100元，您将获得满10-10优惠券；后续每1次在APP上充值超过100元，您都将获得满6-5优惠券（充值指单个有效订单的金额）；
          </span>
        </div>
        <div class="rule-item">
          <img src="@/assets/images/active-4.png" alt="" />
          <span>
            对于刷取奖励的行为，我们有权取消奖励，在法律允许的范围内我们拥有最终解释权；</span
          >
        </div>
      </div>
    </div>
  </van-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    noticeInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit("input", val);
      },
    },
  },
  mounted() {},
  methods: {
    confirm() {
      this.dialogVisible = false;
      if (this.noticeInfo.jump == 1) {
        this.$router.push({ path: "/gameCircle" });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.active-dialog,
.van-dialog__content {
  overflow: visible; /* 允许内容超出 */
}
.active-rule-container {
  .rule-title {
    width: 750px;
    height: 180px;
  }
  .rule-content {
    width: 750px;
    // height: 100px;
    background: url("~@/assets/images/active-rule-content-bg.png");
    background-size: 100% 100%;
    padding: 33px 92px 33px 79px;

    .rule-item {
      display: flex;
      align-items: center;
      margin-bottom: 32px;

      img {
        width: 50px;
        height: 50px;
        margin-right: 18px;
      }
      span {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 30px;
        color: #000000;
        line-height: 46px;
      }
    }
  }
  .close {
    width: 36px;
    height: 36px;
    position: absolute;
    right: 83px;
    top: 65px;
  }
}
.van-dialog {
  background: transparent;
}
</style>


// WEBPACK FOOTER //
// src/components/ActiveRuleDialog.vue